import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  customerId: null,
  family: {},
  me: {},
  tasksCount: 0,
  notesCount: 0,
  buttonsExpanded: false,
  familyLoaded: false,
  showCreateNoteModal: false,
  showViewNoteModal: false,
  editNoteId: null,
  viewNoteId: null,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
